import * as React from 'react';
import { Combobox } from './combobox.js';
import type { SelectOption } from './select.js';

export interface MultiSelectProps {
  options: readonly SelectOption[];
  value: readonly string[];
  onValueChange: (value: string[]) => void;
  /** Shown when nothing is selected (e.g. "Todos los proyectos"). */
  placeholder?: string;
  searchPlaceholder?: string;
  emptyText?: string;
  disabled?: boolean;
  id?: string;
  className?: string;
  'aria-label'?: string;
  'aria-invalid'?: boolean;
  'aria-describedby'?: string;
  'aria-required'?: boolean;
}

/** Searchable multiple selection (Combobox in multiple mode) with Spanish defaults. */
export const MultiSelect = React.forwardRef<
  HTMLButtonElement,
  MultiSelectProps
>(function MultiSelect(
  {
    placeholder = 'Todos',
    searchPlaceholder = 'Buscar…',
    emptyText = 'Ninguna opción coincide',
    ...rest
  },
  ref,
) {
  return (
    <Combobox
      ref={ref}
      multiple
      placeholder={placeholder}
      searchPlaceholder={searchPlaceholder}
      emptyText={emptyText}
      {...rest}
    />
  );
});

/** Maps records to options, e.g. `toOptions(projects, (p) => p.id, (p) => p.name)`. */
export function toOptions<T>(
  items: readonly T[],
  getValue: (item: T) => string,
  getLabel: (item: T) => string,
): SelectOption[] {
  return items.map((item) => ({
    value: getValue(item),
    label: getLabel(item),
  }));
}
